/**
 * Tour guide page types. Each value is sent as `type` to /api/tourguide.
 */
export enum TourGuideType {
  UnauthenticatedDashboard = 1,
  UnauthenticatedCourses = 2,
  UnauthenticatedCourseDetail = 3,
  JournalistDashboard = 4,
  JournalistCourses = 5,
  JournalistCourseDetail = 6,
  JournalistNotice = 7,
  JournalistMyLearning = 8,
  JournalistCustomerCenter = 9,
  JournalistUpdateProfile = 10,
  AdminDashboard = 21,
  PledgeDashboard = 11,
  PledgeManageCourses = 12,
  PledgeCourseDrawer = 13,
  PledgeJournalistManagement = 14,
  PledgeJournalistList = 15,
  PledgeNotice = 16,
  PledgeDepartmentManagement = 17,
  PledgeSubSubscriberManagement = 18,
  PledgeUpdateProfile = 19,
}

export interface TourGuideItem {
  type: TourGuideType;
  isDone: boolean;
}
